"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var Dropdown =
/** @class */
function (_super) {
  __extends(Dropdown, _super);

  function Dropdown() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {
      isOpen: false
    };

    _this.onContainerClickSelfAndOutside = function () {
      return _this.hideList();
    };

    _this.onAreaClick = function () {
      return _this.toggleList();
    };

    _this.onOverlayClick = function () {
      return _this.hideList();
    };

    return _this;
  }

  Object.defineProperty(Dropdown.prototype, "isOpen", {
    get: function get() {
      if (this.props.open === true) {
        return true;
      }

      if (this.props.open === false) {
        return false;
      }

      return this.state.isOpen;
    },
    enumerable: true,
    configurable: true
  });

  Dropdown.prototype.render = function () {
    var renderContainer = this.props.renderContainer;
    return renderContainer({
      onClickSelfAndOutside: this.onContainerClickSelfAndOutside,
      areaJsx: this.renderArea(),
      overlayJsx: this.renderOverlay()
    });
  };

  Dropdown.prototype.renderArea = function () {
    var renderArea = this.props.renderArea;
    return renderArea({
      open: this.isOpen,
      onClick: this.onAreaClick
    });
  };

  Dropdown.prototype.renderOverlay = function () {
    var renderOverlay = this.props.renderOverlay;
    var isOpen = this.isOpen;

    if (!isOpen) {
      return;
    }

    return renderOverlay({
      closeOverlay: this.onOverlayClick
    });
  };

  Dropdown.prototype.toggleList = function () {
    var _a = this.props,
        onChangeExpandState = _a.onChangeExpandState,
        open = _a.open;

    if (open === true && onChangeExpandState) {
      onChangeExpandState(false);
      return;
    }

    if (open === false && onChangeExpandState) {
      onChangeExpandState(true);
      return;
    }

    this.setState(function (_a) {
      var isOpen = _a.isOpen;
      var newIsOpen = !isOpen;

      if (onChangeExpandState) {
        onChangeExpandState(newIsOpen);
      }

      return {
        isOpen: newIsOpen
      };
    });
  };

  Dropdown.prototype.hideList = function () {
    var _a = this.props,
        onChangeExpandState = _a.onChangeExpandState,
        open = _a.open;

    if (onChangeExpandState && open !== false) {
      onChangeExpandState(false);
    }

    if (open !== void 0) {
      return;
    }

    this.setState({
      isOpen: false
    });
  };

  return Dropdown;
}(React.Component);

exports.default = Dropdown;